import React from "react";
import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";
import Grid2 from "@mui/material/Grid2";
import Widget from "../Common/Widget/Widget";
import { SectionHeading } from "../Common/Typography/AppTypography";
import LocationMap from "./LocationMap";

const Meta = ({ label, value }) => (
  <Box>
    <Typography variant="caption" color="text.secondary">
      {label}
    </Typography>
    <Typography variant="body1" fontWeight={600}>
      {value ?? "—"}
    </Typography>
  </Box>
);

const LocationSection = ({ lat, lon, city, weatherLocation }) => (
  <Box sx={{ mb: 3 }}>
    <SectionHeading sx={{ mb: 1.5 }}>Space Location</SectionHeading>
    <Widget disableHeaderDivider>
      <Grid2 container spacing={2}>
        <Grid2 size={{ xs: 12, md: 7 }}>
          <LocationMap
            lat={lat}
            lon={lon}
            height={260}
            label={weatherLocation || city}
          />
        </Grid2>
        <Grid2 size={{ xs: 12, md: 5 }}>
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: { xs: "1fr 1fr", sm: "1fr" },
              gap: 2,
              height: "100%",
              alignContent: "center",
            }}
          >
            <Meta label="Latitude" value={lat} />
            <Meta label="Longitude" value={lon} />
            <Meta label="City" value={city} />
            <Meta label="Space Location" value={weatherLocation} />
          </Box>
        </Grid2>
      </Grid2>
    </Widget>
  </Box>
);

LocationSection.propTypes = {
  lat: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  lon: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  city: PropTypes.string,
  weatherLocation: PropTypes.string,
};

Meta.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default LocationSection;
